// Preços de exemplo da página inicial (PAC saindo de Fortaleza, 300 g), calculados ao vivo.
// Uma consulta só por visita: Hero e "Quanto você economiza" usam o mesmo resultado.
import { useEffect, useState } from 'react';
import { calcularFrete } from './api';

export const ORIGEM = { nome: 'Fortaleza', uf: 'CE', cep: '60175047' };
export const DESTINOS = [
  { nome: 'São Paulo', uf: 'SP', cep: '01310100' },
  { nome: 'Rio de Janeiro', uf: 'RJ', cep: '20040020' },
  { nome: 'Belo Horizonte', uf: 'MG', cep: '30130010' },
  { nome: 'Brasília', uf: 'DF', cep: '70040010' },
];

let consulta = null;
function buscarPrecos() {
  if (!consulta) {
    consulta = Promise.all(DESTINOS.map(async (d) => {
      try {
        const r = await calcularFrete({ cep_origem: ORIGEM.cep, cep_destino: d.cep, peso_g: 300, servicos: ['04510'] });
        const pac = (r.resultados || []).find((x) => x.codigo === '04510' && !x.erro && x.valor > 0);
        return pac ? { ...d, valor: pac.valor, balcao: pac.valor_sem_desconto } : null;
      } catch { return null; }
    })).then((lista) => lista.filter(Boolean));
  }
  return consulta;
}

export function usePrecosRotas() {
  const [rotas, setRotas] = useState(null);
  useEffect(() => {
    let vivo = true;
    buscarPrecos().then((l) => { if (vivo) setRotas(l); });
    return () => { vivo = false; };
  }, []);
  return rotas;
}

export const brl = (v) => Number(v).toFixed(2).replace('.', ',');
